var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiyal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 12.5497,
    height: 14,
    viewBox: "0 0 12.5497 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 38020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2182",
    d: "M7.36732 1.95061C7.89977 1.37078 8.22575 1.09907 8.85011 0.729127V9.0075L12.5414 8.24792C12.5008 8.61537 12.4615 8.77141 12.39 9.03829C12.3186 9.30517 12.2509 9.526 12.1185 9.82353L7.36732 10.8141V1.95061Z",
    fill: "#030F1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2183",
    d: "M5.90593 0C5.13843 0.441296 5.0079 0.605609 4.42464 1.19063V10.3108L0.423779 11.1576C0.204493 11.5374 -0.0147933 12.7075 0.00087004 12.7281C0.0165333 12.7486 4.22324 11.8248 4.35004 11.8248C4.59595 11.7119 4.75207 11.6451 4.91914 11.445C5.08622 11.2448 5.3055 10.9112 5.3055 10.9112L5.72841 10.2748C5.85588 10.0953 5.89736 9.98694 5.90593 9.777V0Z",
    fill: "#030F1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2184",
    d: "M1.12661 7.77975L12.5497 5.36364C12.4374 6.07047 12.3388 6.42007 12.1059 6.96568L0.703729 9.38179C0.784529 8.77839 0.849268 8.43527 1.12661 7.77975Z",
    fill: "#030F1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2185",
    d: "M7.78844 12.3768L12.544 11.3956C12.4532 12.0563 12.3626 12.4084 12.116 12.9979L7.35516 14C7.46238 13.3721 7.55874 13.0194 7.78844 12.3768Z",
    fill: "#030F1B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiyal);
export default __webpack_public_path__ + "static/media/riyal.d1f170cdaf4fea6295cfcb0378355491.svg";
export { ForwardRef as ReactComponent };